import React, {  useContext, useEffect, useState } from 'react';
import { LegalAndRegTextInterface, DataLegalAndRegTextContext, ShowLegalAndRegTextsContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsLegalAndRegText from './forms/InputsLegalAndRegText';
import { useDispatch } from 'react-redux';
import { EditLegalAndRegTextApi } from '../../redux/legal_and_regulator_text/legalAndRegulatorTextApiCalls';
import { Timeout } from '../../functions/functions';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean, 
  toggle: () => void,
  LegalAndRegTextData: LegalAndRegTextInterface
}

const EditLegalAndRegText:React.FC<props> = ({ modal, toggle, LegalAndRegTextData }) => {
  const [title, setTitle] = useState("")
  const [image, setImage] = useState<File | any>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setTitle(LegalAndRegTextData.title)
    setImage(LegalAndRegTextData.image)
  }, [LegalAndRegTextData])

  const [errors, setErrors] = useState<string[]>([])

  const { setShowSuccessMsg } = useContext(ShowLegalAndRegTextsContext)
  const dispatch:any = useDispatch()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("title", title)
      formData.append("image", image)
      const response: any = await dispatch(EditLegalAndRegTextApi(LegalAndRegTextData._id, formData))
        if(response === true) {
          setTitle("")
          setImage(null)
          setShowSuccessMsg(true)
          toggle()
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
    } finally {
      setLoading(false)
    }
  }


  return (
    <DataLegalAndRegTextContext.Provider 
      value={{
        title, setTitle,
        image, setImage,
      }}
    >
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsLegalAndRegText />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn='Modifier' />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataLegalAndRegTextContext.Provider>
  );
}

export default EditLegalAndRegText

// {/* {errors.length > 0 &&
// errors.map((err, index) => (
//   <p
//     className="p-3 my-2 rounded bg-red text-white msg"
//     key={index}
//     onClick={(e) => hideMsg(e, errors, setErrors)}
//   >
//     {err}
//   </p>
// ))} */}